// Unregisters any previously installed caching service worker and clears its
// caches.  The self-destroying sw.js in public/ handles the heavy lifting for
// users who already have the old SW active — this function covers edge cases
// where the browser still holds a registration but hasn't fetched the new sw.js.

export function unregisterAndCleanup() {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      // Keep the Firebase Messaging SW — only nuke our caching SW
      if (
        registration.active?.scriptURL?.includes('firebase-messaging-sw') ||
        registration.installing?.scriptURL?.includes('firebase-messaging-sw') ||
        registration.waiting?.scriptURL?.includes('firebase-messaging-sw')
      ) {
        return;
      }
      registration.unregister();
    });
  });

  // Clear any leftover caches from the old SW
  if ('caches' in window) {
    caches.keys().then((keys) => {
      keys.forEach((key) => {
        if (key.startsWith('dineo-')) {
          caches.delete(key);
        }
      });
    });
  }
}
